import { render, staticRenderFns } from "./NewInsuranceModal.vue?vue&type=template&id=b1bace68"
import script from "./NewInsuranceModal.vue?vue&type=script&lang=js"
export * from "./NewInsuranceModal.vue?vue&type=script&lang=js"
import style0 from "./NewInsuranceModal.vue?vue&type=style&index=0&id=b1bace68&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports